<wiz-vgroup maxHeight="250px" width="100%" gap=0>
    <!-- container fixe permettant d'aligner à droite les drapeaux -->
    <wiz-vgroup width="100%" horizontalAlign="end" >
      <div gap="10" width="auto" class="translation-flag-list" padding="0 0 0 0" #flagContainer>
        <ng-container *ngFor="let entry of trimEntries">
          <!-- container de l'image pour la bordure lors de la selection -->
          <div class="translation-flag-container" [ngClass]="{'container-selected-flag': entry.languageCode === currentLanguage.languageCode}">
            <wiz-image #imgFlag [sourceObservable]="entry.languageIcon"
                      tabindex="0"
                      [id]="entry.languageCode"
                      (click)="changeTranslationLanguage(entry)"
                      (keydown)="keydownChangeLanguage($event, entry)" 
                      (focus)="onFocusIn($event)"
                      [ngClass]="{'selected-translation-flag': entry.languageCode === currentLanguage.languageCode}" 
                      class="translation-flag"
                      [useHandCursor]=true
                      height="16px" width="16px">
            </wiz-image>
          </div>
        </ng-container>
      </div>
    </wiz-vgroup>
  <wiz-vgroup #inputContainer width="100%" height="100%" class="input-container" padding="10px 10px 0 10px">
    <ng-container *ngTemplateOutlet="template" width="100%"></ng-container>
  </wiz-vgroup>
</wiz-vgroup>

<ng-template #TextinputTpl>
  <wiz-text-input #tiLabel
                  [wizValue]="currentLanguage?.label"
                  [wizShowLabel]=false
                  [manageModel]=false width="100%">
  </wiz-text-input>
</ng-template>

<ng-template #TextareaTpl>
  <wiz-text-area #tiLabel
                  [wizValue]="currentLanguage?.label"
                  [wizShowLabel]=false
                  [manageModel]=false width="100%">
  </wiz-text-area>
</ng-template>
